import axios from "axios";

const rawBackendUrl =
  process.env.REACT_APP_BACKEND_URL ||
  (typeof window !== "undefined" ? window.location.origin : "");

// REACT_APP_BACKEND_URL should be the site/backend origin, not a path ending in /api.
// Normalize defensively so a mistaken value like https://site/api does not become /api/api.
const BACKEND_URL = rawBackendUrl.replace(/\/$/, "").replace(/\/api$/, "");
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  timeout: 120000,
});

export const ingestMeasure = (payload) =>
  api.post("/measures/ingest", payload).then((r) => r.data);

export const lookupBill = (payload) =>
  api.post("/bills/lookup", payload).then((r) => r.data);

export const listMeasures = () =>
  api.get("/measures").then((r) => r.data);

export const getMeasure = (id) =>
  api.get(`/measures/${id}`).then((r) => r.data);

export const getStatus = (id) =>
  api.get(`/measures/${id}/status`).then((r) => r.data);

export const getReport = (id) =>
  api.get(`/measures/${id}/report`).then((r) => r.data);

export const getSources = (id) =>
  api.get(`/measures/${id}/sources`).then((r) => r.data);

export const analyzeMeasure = (id, body = {}) =>
  api.post(`/measures/${id}/analyze`, { force: false, fetch_current_law: true, ...body })
    .then((r) => r.data);

export const deleteMeasure = (id) =>
  api.delete(`/measures/${id}`).then((r) => r.data);

export const getQuoteContext = (id, quote) =>
  api.post(`/measures/${id}/quote-context`, { quote }).then((r) => r.data);

export const getAuthors = (id) =>
  api.get(`/measures/${id}/authors`).then((r) => r.data);

export const getConflicts = (id, adjudicate = true, force = false) =>
  api
    .get(`/measures/${id}/conflicts`, { params: { adjudicate, force } })
    .then((r) => r.data);

export const getFinance = (id) =>
  api.get(`/measures/${id}/finance`).then((r) => r.data);

export const ingestFinance = (id, urls) =>
  api.post(`/measures/${id}/finance`, { urls }).then((r) => r.data);

export const getLinkages = (id) =>
  api.get(`/measures/${id}/linkages`).then((r) => r.data);

export const getEntity = (entityId) =>
  api.get(`/graph/entity`, { params: { entity_id: entityId } }).then((r) => r.data);

export const fetchCodeSection = (id, code, section) =>
  api.post(`/measures/${id}/code-section`, { code, section }).then((r) => r.data);

export const createSupportCheckout = (payload) =>
  api.post("/support/checkout", payload).then((r) => r.data);

export const getSupportStats = () =>
  api.get("/support/stats").then((r) => r.data);

export const createDossierCheckout = (payload) =>
  api.post("/dossier/checkout", payload).then((r) => r.data);

export const adminOverview = (token) =>
  api.get("/admin/overview", { headers: { "X-Admin-Token": token } }).then((r) => r.data);

export const adminListSupporters = (token) =>
  api.get("/admin/supporters", { headers: { "X-Admin-Token": token } }).then((r) => r.data);

export const adminListDossiers = (token) =>
  api.get("/admin/dossiers", { headers: { "X-Admin-Token": token } }).then((r) => r.data);

export const adminMarkDossierDelivered = (token, id, delivered_url) =>
  api
    .post(
      `/admin/dossiers/${id}/mark-delivered`,
      { delivered_url },
      { headers: { "X-Admin-Token": token } }
    )
    .then((r) => r.data);

export const getRecentBills = (params = {}) =>
  api.get("/recent-bills", { params }).then((r) => r.data);

export const adminTriggerBillScan = (token) =>
  api.post("/admin/new-bill-scan", {}, { headers: { "X-Admin-Token": token } }).then((r) => r.data);

export const listBallotMeasures = () =>
  api.get("/ballot-measures/list").then((r) => r.data);

export const resolveBallotMeasure = (payload) =>
  api.post("/ballot-measures/resolve", payload).then((r) => r.data);

export const checkClaim = (mid, claim, claim_source) =>
  api
    .post(`/measures/${mid}/check-claim`, { claim, claim_source })
    .then((r) => r.data);

export const listClaimLibrary = (mid) =>
  api.get(`/measures/${mid}/claim-library`).then((r) => r.data);

export default api;
